import React from 'react';

import { NavLink } from 'react-router-dom';

//Styles
import './Footer.scss';

//Icons
import BackToTop from '../Icons/BackToTop';

function Footer(props){
    return(
        <div className="footer">
            <div className="container">
                <div className="container-inner">
                    <iframe title="map" src="https://maps.google.com/maps?width=600&height=400&hl=en&q=washama road &t=&z=14&ie=UTF8&iwloc=B&output=embed" width="80%" height="450" frameBorder="0"  allowFullScreen="" aria-hidden="false" tabIndex="0"></iframe>

                    <div className="column-wrapper">
                        <div className="column">
                            <h5>Navigation</h5>
                            <NavLink to="/" onClick={props.scrollToTop}>Home</NavLink>
                            <NavLink to="/about" onClick={props.scrollToTop}>About Us</NavLink>
                            <NavLink to="/portfolio" onClick={props.scrollToTop}>Portfolio</NavLink>
                            <NavLink to="/contact" onClick={props.scrollToTop}>Contact</NavLink>
                            {/* <NavLink to="/rental" onClick={props.scrollToTop}>To Rent</NavLink> */}
                        </div>

                        <div className="column">
                            <h5>Contact</h5>
                            <a href="tel:+260971564418">+260971564418</a>
                            <a href="tel:+260975112233">+260975112233</a>
                            <a href="mailto:ravlot007@gmail.com">ravlot007@gmail.com</a>
                        </div>

                        {/* <div className="column">
                            <h5>Equipment rental</h5>
                            <a href="tel:0900000000">0900 000 000</a>
                            <a href="mailto:ravlot007@gmail.com">ravlot007@gmail.com</a>
                        </div> */}

                        <div className="column">
                            <h5>Address</h5>
                            <p>Plot No. 123/B, Washama Road,</p>
                                    <p>Villa Elizabeth,</p>
                                    <p>Lusaka, Zambia</p>
                        </div>
                    </div>

                    <div className="copyright">
                        <p>&copy; GOLD CONSTRUCTION LIMITED</p>

                        <div className="back-to-top">
                            <BackToTop scrollToTop={props.scrollToTop} />
                            <p onClick={props.scrollToTop}>Back to top</p> 
                        </div>   
                    </div> 
                </div>
            </div> 
        </div>
    )
}

export default Footer;